<template>
  <div class="case-proposal">
    <!-- <div class="item-title">{{$('page_content_suggested_treatment_scheme}}</div> -->
    <div class="table-bd">
      <custom-table
        height="400px"
        :data="tableList"
        :tableCode="tableCode"
        :index="true"
        @filter="filterChange"
        @sort="sortChange"
        :slots="['itemName', 'action']"
        :filterArr="orderType === 'caseOrder' ? [] : ['action']"
      >
        <template v-slot:itemName="scope">
          <span
            class="preview"
            @click="onPreview(scope.row)"
          >{{scope.row.itemName}}</span>
        </template>
        <template v-slot:action="scope">
          <span></span>
          <el-button
            v-if="actionEnable"
            type="text"
            size="mini"
            @click="onEdit(scope.row)"
          >{{$('com_edit')}}</el-button>
          <el-button
            v-if="actionEnable"
            type="text"
            size="mini"
            @click="onDel(scope.row)"
          >{{$('com_delete')}}</el-button>
        </template>
      </custom-table>
    </div>
    <case-proposal-item-dialog
      v-if="caseProposalItemVisible"
      @close="caseProposalItemVisible=false"
      :model="caseProposalItemModel"
      @success="init"
      :orderType="orderType"
      :caseOrderType="caseOrderType"
    ></case-proposal-item-dialog>
  </div>
</template>

<script>
/**
 * 建议处理方案组件
 * 案例订单-维修：
 * 表格列 故障项目，故障代码，处理方案，更新人，更新时间
 * 查看，编辑，删除
 *
 * 工单-维修：
 * 表格列：处理方案，更新人，更新时间
 * 查看，编辑，删除
 */
import apis from '@/utils/apis';
import caseProposalItemDialog from './case_proposal_item_dialog';

export default {
  name: '',
  inject: ['getCaseInfo', 'checkActionEnable'],
  mixins: [],
  components: { caseProposalItemDialog },
  props: {
    orderDeviceId: [Number, String],
    orderType: [Number, String],
    caseOrderType: [Number, String],
  },
  data() {
    return {
      tableList: [],
      totalRows: null,
      caseProposalItemVisible: false,
      caseProposalItemModel: {},
    };
  },
  computed: {
    info() {
      return this.getCaseInfo();
    },
    actionEnable() {
      return this.checkActionEnable();
    },
    tableCode() {
      return this.orderType === 'caseOrder' ? 'case_proposal' : 'case_proposal_work_order';
    },
  },
  watch: {
    orderDeviceId: {
      immediate: true,
      handler(val) {
        if (val) {
          this.init();
        }
      },
    },
  },
  methods: {
    getTableList() {
      this.$getJSON(apis.caseOrderProposalList, {
        orderDeviceId: this.orderDeviceId,
      }).then((res) => {
        this.tableList = res.data;
      });
    },
    init() {
      this.getTableList();
    },
    onDel(row) {
      this.$showConfirm(this.$('cf_tips_del_programme')).then(() => {
        this.$postJSON(`${apis.caseOrderProposalDelete}/${row.orderProposalId}`, {}, true).then(() => {
          this.$message({
            message: this.$('com_delete_success'),
            type: 'success',
          });
          this.getTableList();
        });
      });
    },
    onEdit(row) {
      this.caseProposalItemModel = {
        title: this.$('dialog_title_edit_programme'),
        type: 'edit',
        data: row,
      };
      this.caseProposalItemVisible = true;
    },
    onPreview(row) {
      this.caseProposalItemModel = {
        title: this.$('dialog_title_check_programme'),
        type: 'watch',
        data: row,
      };
      this.caseProposalItemVisible = true;
    },
  },
  created() { },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
.case-proposal {
  padding: 16px;
  .search-hd {
    padding-top: 0;
  }

  .preview {
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }
}
</style>
